<template>
  <div class=" px-4 justify-center max-w-[1000px] max-h-[600px] ">
    <div class="justify-center flex mb-4  ">
      <span class="text-sm w-full" v-html="message"></span>
    </div>
  <div>
    <h1 v-if="!page.lock" class="p-1 text-lg">Welche Märkte möchten sie sperren</h1>
    <h1 v-if="page.lock" class="p-1 text-lg">Welche Märkte möchten sie freigeben</h1>
  </div>
  <div class="grid grid-cols-12 pb-4">
    <div v-for="market in markets" :key="market.marketId" class="">
      <div class="bg-trader-gray p-4 m-2 flex">
        <span class="mr-2">{{ market.name }}</span>
        <input type="checkbox" @click="getMarketIds(market.marketId)" :checked="marketIds.includes(market.marketId)">
      </div>
    </div>
  </div>
  <div class="flex gap-2">
    <button class="p-2 bg-trader-gray" @click="removeAllMarkets" data-ui="deselect-all-markets">Alle Märkte abwählen</button>
    <button class="p-2 bg-trader-gray" @click="getAllMarkets" data-ui="select-all-markets">Alle Märkte auswählen</button>
  </div>
  <div class="w-full flex gap-2 mb-2">
    <button class="bg-trader-red text-trader-dark-red w-1/2 rounded p-2 mt-2" @click="deleteTrue"
            data-ui="delete-yes">Ja
    </button>
    <button class="bg-trader-green w-1/2 rounded p-2 mt-2" @click="deleteFalse" data-ui="delete-no">Nein</button>
  </div>
  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus.js";

export default {
  props: {
    markets: {
      type: Array,
      default: []
    },
    page: {
      type: Object,
      default: []
    },

    onAccept: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {
      markets: this.markets,
      marketIds: [],
      pageIds: [],
      pages: this.pages
    }
  },
  mounted() {
    
    this.getMarkets();
  },
  methods: {
    getAllPages() {
      this.pageIds = this.pages.map(page => page.pageId);
    },
    getAllMarkets() {
      this.marketIds = this.markets.map(market => market.marketId);
    },
    removeAllMarkets() {
      this.marketIds = [];
    },
    getMarketIds(marketId) {
      if (this.marketIds.includes(marketId)) {
        this.marketIds = this.marketIds.filter(id => id !== marketId);
      } else {
        this.marketIds.push(marketId);
      }
    },
    getPageIds(pageId) {
      if (this.pageIds.includes(pageId)) {
        this.pageIds = this.pageIds.filter(id => id !== pageId);
      } else {
        this.pageIds.push(pageId);
      }
    },
    async getMarkets() {
      const query = gql`
        query getMarkets {
          getMarkets  {
            marketId
            name
            description
            isActive
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({query});
        this.markets = data.getMarkets;
      } catch (error) {
        console.error(error);
      }
    },
    deleteTrue() {
      eventBus.closeModal();
      try {
        if (this.onAccept) {
          this.onAccept(this.marketIds, this.pageIds);
        }
      } catch (e) {
      }
    },
    deleteFalse() {
      eventBus.closeModal();
      try {
        if (this.onCancel) {
          this.onCancel();
        }
      } catch (e) {
      }
    }
  },
}


</script>

